import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Input, InputProps } from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface ColorInputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const ColorInputForm = ({
  name,
  label,
  isRequired,
  register,
  errors,
  ...rest
}: ColorInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={2}>
      <FormLabel fontWeight="bold" mb={1} htmlFor={name}>
        {label}
      </FormLabel>
      <Input
        type="color"
        id={name}
        background="theme.light.bodyInput"
        boxShadow="0px 2px 4px #00000050"
        {...register(name)}
        {...rest}
      />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
